import { useRef } from "react";
import { useState } from "react";


const MAX_COUNT = 5;

const MyRequest = () => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileLimit,setFileLimit] = useState(false);
    const [filename, setFileName] =useState();
  
    const inputRef = useRef(null);
    const handleClick = () => {
      // 👇️ open file input box on click of other element
      inputRef.current.click();
  
    };
  
    const handleUploadFiles = files => {
      const uploaded = [...uploadedFiles];
      let limitExceeded = false;
      files.some((file) => {
        if(uploaded.findIndex((f) => f.name === file.name) === -1){
          uploaded.push(file);
        }
       })
  if (!limitExceeded) setUploadedFiles(uploaded)   
   }
  const handleFileEvent = (e) => {
    const chosenFiles =Array.prototype.slice.call(e.target.files)
    handleUploadFiles(chosenFiles);
  
    const fileObj = e.target.files && e.target.files[0];
    if (!fileObj) {
      return;
    }
    e.target.value = null;
    setFileName({...filename , name: fileObj.name, size: fileObj.size, type: fileObj.type});
   }



    return(
<>
<div className="outer-wrapper">
    <div className="inner-wrapper  items-center ">
      <div className="bg-[#efefef] flex flex-col justify-center items-center min-h-[180px] py-[2rem] ">
        <h1 className="text-[30px] sm:text-[40px] font-bold ">My Request</h1>
      </div>
    </div>
  </div>
            

  <div className="outer-wrapper my-[3rem]">
    <div className="inner-wrapper sm:flex block flex-col justify-center items-center mt-[1rem]  ">
      <div className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[53rem] sm:w-[40rem] w-[auto]  mx-[1rem] rounded-md transition-all duration-500">
        <div className="flex justify-between">
          <h2 className="font-bold text-[1.1rem] leading-5">My Request</h2>
          <button className="text-white bg-[#D40511] h-[2rem] border border-[#F21E26] sm:w-[10rem] rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
          New Booking
          </button>

        </div>

        <table className="mt-6 rounded-3xl">
          <thead className="">
            <tr className="text-left bg-gray-100">
              <th className="border p-2 text-center">S.no</th>
                <th className="border p-2 text-center">Request ID</th>
                <th className="border p-2 text-center" >Date</th>
                <th className="border p-2 text-center" >Name</th>
                <th className="border p-2 text-center" >Mobile No.</th>
                <th className="border p-2 text-center" >Type</th>
                <th className="border p-2 text-center" >Payment</th>
                <th className="border p-2 text-center">Status</th>
                <th className="border p-2 text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border p-2 text-center">01</td>
              <td className="border p-2 text-center">ATT-001</td>
              <td className="border p-2 text-center">05-May-2022</td>
              <td className="border p-2 text-center">Ali Khan</td>
              <td className="border p-2 text-center">021-33373839</td>
              <td className="border p-2 text-center">Original</td>
              <td className="border p-2 text-center">Received</td>
              <td className="border p-2"><button className="text-white bg-[#25C275] h-[2rem] border border-[#25C275] sm:w-[8rem] rounded-full  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Approved</button></td>
              <td className="border p-2 "> <img src="/nrp-icons/booking-icon/edit.svg" alt=""className=" h-25 lg:w-[1.5rem] w-[2rem] ml-[1rem]"/></td>
            
            </tr>
            <tr>
              <td className="border p-2 text-center">02</td>
              <td className="border p-2 text-center">ATT-002</td>
              <td className="border p-2 text-center">06-June-2022</td>
              <td className="border p-2 text-center">Khurram Jaleel</td>
              <td className="border p-2 text-center">021-33373839</td>
              <td className="border p-2 text-center">Duplicate</td>
              <td className="border p-2 text-center">Pending</td>
              <td className="border p-2"><button className="text-white bg-[#25C275] h-[2rem] border border-[#25C275] sm:w-[8rem] rounded-full  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Approved</button></td>
              <td className="border p-2 text-center"><img src="/nrp-icons/booking-icon/edit.svg" alt=""className="react-reveal h-25 lg:w-[1.5rem] w-[2rem] ml-[1rem]"/></td>
              
            </tr>
            <tr>
            <td className="border p-2 text-center">03</td>
              <td className="border p-2 text-center">ATT-003</td>
              <td className="border p-2 text-center"><button>07-July-2022</button></td>
              <td className="border p-2 text-center">Waheed Zulfiqar</td>
              <td className="border p-2 text-center">021-33373839</td>
              <td className="border p-2 text-center">Original</td>
              <td className="border p-2 text-center">Received</td>
              <td className="border p-2 "><button className="text-white bg-[#D40511] h-[2rem] border border-[#F21E26] sm:w-[8rem] rounded-full  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Pending</button></td>
              <td className="border p-2"><img src="/nrp-icons/booking-icon/edit.svg" alt=""className="react-reveal h-25 lg:w-[1.5rem] w-[2rem] ml-[1rem]"/></td>
            
            </tr>
                
          </tbody>
      </table>

      </div>
    </div>
  </div>

     {/* ATT-001 */}
  <div className="outer-wrapper my-[3rem]">
    <div className="inner-wrapper sm:flex block flex-col justify-center items-center mt-[1rem]  ">

    <div className="flex flex-col gap-3 p-8 px- shadow-card text-sm md:w-[53rem] sm:w-[40rem] w-[auto] rounded-md transition-all duration-500">
      <div className="flex justify-between">
        <h2 className="font-bold text-[1.1rem] leading-5">ATT-001</h2>
      </div>

    <div className="sm:flex grid gap-4">
      <div className="MuiFormControl-root MuiTextField-root flex-1">
        <div className="relative w-[24rem]">
            <input
              type="text"
              id="floating_outlined"
              className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
              placeholder=" "
            />
            <label
              for="floating_outlined"
              className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
            >Ali Haider 
            </label>
        </div>
      </div>
      <div className="MuiFormControl-root MuiTextField-root flex-1">
        <div className="relative w-[24rem]">
          <input
          type="text"
          id="floating_outlined"
          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
          placeholder=" "
          />
          <label
          for="floating_outlined"
          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
          >Alihaider@gmail.com 
          </label>
        </div>
      </div>
    </div>

    <div className="sm:flex grid gap-4">
      <div className="MuiFormControl-root MuiTextField-root flex-1">
        <div className="relative w-[24rem]">
          <input
            type="text"
            id="floating_outlined"
            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
            placeholder=" "
          />
          <label
            for="floating_outlined"
            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
          >Karachi University <span className="text-[#F21E26]">*</span>
          </label>
        </div>
      </div>  

      <div className="MuiFormControl-root MuiTextField-root flex-1">
        <div className="relative w-[24rem]">
          <input
            type="text"
            id="floating_outlined"
            className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
            placeholder=" "
          />
          <label
            for="floating_outlined"
            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
          >Document type 
          </label>
        </div>
      </div>
    </div>

    <div className="MuiFormControl-root flex-1" inputprops="[object Object]" inputlabelprops="[object Object]">
        <div className="border-dashed ">
          {/* <div className="MuiFormControl-root MuiTextField-root flex-1"> */}
            <div className="relative w-[49rem] text-black border-dashed border-2 bg-[#efefef]">
              <div className='flex justify-between p-1'>
                <p className='text-[#9E9E9E] font-medium'>Upload File</p>
                <p className='text-[#9E9E9E]'>Documents should be in <a href='#'><b>pdf</b></a> form</p>
              </div>
              <input id='fileUpload' type='file' multiple 
                    style={{ display: 'none'}}
                    accept='application/pdf, image/png'
                    onChange={handleFileEvent}
                    disabled={fileLimit}
                    ref={inputRef}
                />
              <button onClick={handleClick} className="file-btn flex w-[49rem] justify-center"> 
                <img src="/nrp-icons/booking-icon/upload-file-icon.svg" alt="" className="h-10"/>
              </button>
              <p className='text-center pt-2 pb-2 text-[#9E9E9E] font-bold'>Drag and drop or brows files to upload!</p>
              
            </div>
          {/* </div> */}
          
        </div>
      </div>
      <div className="flex ">
      {uploadedFiles.map(file => (
        <div className='flex bg-[#efefef] p-2 w-[14rem] mr-2'>
        <img src='/nrp-icons/booking-icon/image-icon.svg'alt='' className='w-[2rem] h-5'/>
        <p>{file.name} </p>
        <img src='/nrp-icons/booking-icon/delete.svg' alt='' className='w-[2rem] h-5 '/>
          </div>
        ))} 
      </div>

    <div className="sm:flex grid gap-4">
      <div className="MuiFormControl-root MuiTextField-root flex-1">
        <div className="relative w-[49rem]">
          <input
            type="text"
            id="floating_outlined"
            className="block px-2.5 p-10 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
            placeholder=" "
          />
          <label
            for="floating_outlined"
            className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/4 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
          >Comment Goes
          </label>
        </div>
      </div>
      

    </div>
        
    <button 
    //   onClick={() => handleNext()}
      // onClick={previousSlider}
      className="text-white bg-[#D40511] h-[2.5rem] border border-[#F21E26] w-[100%] sm:w-[49rem]  rounded-md  p-1 text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">
      Save
      {/* {activeStepper === steps.length - 1 ? 'Finish' : 'Next'} */}
    </button>
    </div>
    </div>
  </div>






</>

    )
}
export default MyRequest;